import React from "react";

const AdSpace: React.FC = () => {
  return (
    <img
      className="w-full h-[150px] md:h-[260px] object-cover  rounded-xl object-left-top "
      src="/images/ad-space.png"
      alt="google-ads "
    />
  );
};

export default AdSpace;
